import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, CMSImageBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface RegistrationBannerAPI extends CMSApiBase {
  background: CMSImageBase;
  character: CMSImageBase;
  title: string;
  moneyValue: number;
  bonus: string;
  subTitle: string;
  banks: CMSImageBase[];
}

export const registrationBannerCMSV3 = (lang: string) =>
  request<RegistrationBannerAPI>({
    url: buildCmsUrl({ path: 'registration-banner', lang }),
  });

export const registrationBannerCMSV4 = (lang: string) =>
  request<RegistrationBannerAPI>({
    url: buildCmsUrl({
      path: 'registration-banner',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<RegistrationBannerAPI>
    ),
  });

export const registrationBannerCMS = isCMSV3
  ? registrationBannerCMSV3
  : registrationBannerCMSV4;
